import React from 'react';

class Banner extends React.Component {
  render() {
    const { bannersActive } = this.props;

    return (
      <div className="containerBanner">
        {bannersActive.map((banner) => (
          <div className="banner">
            <div className="bannerContent" style={{ background: banner.color }}>
              <div
                className="banner-text"
                style={{ fontSize: banner.fontSize }}
              >
                {banner.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default Banner;
